import React from 'react';
import styled from 'styled-components';
import type { HotelMapPopupProps } from 'src/components/YandexMap/types';

export const HotelMapPopup = ({
  className,
  isMobile = false,
  image,
  title,
  text,
}: HotelMapPopupProps) => (
  <StyledContainer className={className} isMobile={isMobile}>
    {image}
    <StyledHeader isMobile={isMobile}>{title}</StyledHeader>
    {text && <StyledText isMobile={isMobile}>{text}</StyledText>}
  </StyledContainer>
);

const StyledContainer = styled.div<{ isMobile: boolean }>`
  position: relative;
  padding: ${(props) => (props.isMobile ? '10px 30px' : '20px 50px')};
  display: flex;
  overflow: hidden;
  max-width: 90%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.theme.colors.white};
  border-radius: ${(props) => props.theme.shape.borderRadius};
  box-shadow: 0 2px 15px 0 rgba(93, 104, 113, 0.3);
`;

const StyledHeader = styled.div<{ isMobile: boolean }>`
  margin-bottom: 8px;
  font-size: ${({ isMobile }) => (isMobile ? '18px' : '22px')};
  font-weight: 500;
  text-align: center;
  white-space: pre-line;
  color: ${(props) => props.theme.colors.blackBase};
`;

const StyledText = styled.div<{ isMobile: boolean }>`
  font-size: ${({ isMobile }) => (isMobile ? '13px' : '14px')};
  text-align: center;
  white-space: pre-line;
  color: ${(props) => props.theme.colors.blackLight};
`;
